import { NonIdealState } from '@blueprintjs/core';
import PropTypes from 'prop-types';
import React from 'react';

// TODO 264 Add button to add person to Ancestry?
// - Maybe also try to logout and login.
const PersonCardEmpty = ({ className }) => (
  <NonIdealState
    // action={this.state.action ? action : undefined}
    className={className}
    description="The are no people to select from. Add some people to your Ancestry first."
    icon="person"
    title="No people available"
  />
);

PersonCardEmpty.defaultProps = {
  className: undefined,
};

PersonCardEmpty.propTypes = {
  className: PropTypes.string,
};

export default PersonCardEmpty;
